import { PublicCallback } from 'globals/types';
import { handleError } from 'globals/errors';
import { getFeaturedArticlesForKnowledgeBase } from 'core_main/api/articles';
import {
  createArticleCallbackResponse,
  createArticlesCallbackResponse,
} from 'core_main/sdk/get_articles/helpers';
import { GetFeaturedArticlesParameters } from './types';

export const fetchFeaturedArticles = (
  parameters: GetFeaturedArticlesParameters,
) => {
  return getFeaturedArticlesForKnowledgeBase(parameters).then((res) => {
    const articles = res;

    if (!articles || !articles.length) return [];

    return articles.map((a) => {
      return createArticleCallbackResponse(a);
    });
  });
};

export const getFeaturedArticles = (
  parameters: GetFeaturedArticlesParameters,
  cb?: PublicCallback,
) => {
  return fetchFeaturedArticles(parameters)
    .then((articles) => {
      const callbackResponse = createArticlesCallbackResponse(articles);

      if (typeof cb === 'function') {
        cb(callbackResponse);
      }
    })
    .catch((error) => {
      if (typeof cb === 'function') cb(null, error);
      handleError(error, { message: 'Failed to get articles' });
    });
};
